module.exports = __webpack_public_path__ + "static/media/slide1_mobile_small.890cc60b.jpg";